export default __webpack_public_path__ + "static/media/093-diagonal-arrow-3.c2cd9167.png";